module.exports = {
  fetch: `query getMoulages {
    moulages(sortBy: "displayOrder") {
      id
      category
      variation
      label {
        en
        es
      }
      picture {
        url
      }
      thumbnail {
        url
      }
      unavailableRegions
      bodyTypeRestrictions
      stanceRestrictions
      isStructural
      structuralOverride
      productTypes
      physicalRepercussions {
        type
        location
        metadata {
          __typename
          ...on ForcedMoulagePhysicalRepercussionMetadata {
            moulage {
              category
              variation
              label {
                en
                es
              }
              picture {
                url
              }
              thumbnail {
                url
              }
            }
          }
        }
      }
    }
  }`,
};
